import { useState } from "react";
import * as ReactBootStrap from "react-bootstrap";
import axios from "axios";

function InvoiceAnalyzer() {
    const [invoiceData, setInvoiceData] = useState(null);
    const [img, setImg] = useState(null);
    const [loading, setLoading] = useState(true);

    const onChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = function () {
            const base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
            setImg("b " + base64String); // Add "b " prefix
        };
        reader.readAsDataURL(file);
    };

    const submit = async () => {
        if (!img) {
            alert("Please upload a file first.");
            return;
        }

        setLoading(false);
        setInvoiceData(null); // Reset previous data

        const formData = new FormData();
        formData.append("ImageByte", img); // Sending Base64 inside FormData

        const config = {
            method: "post",
            url: "https://7v0avnkws5.execute-api.ap-south-1.amazonaws.com/default/invoicne_data",
            headers: {
                // "x-api-key": "hY2CRZTMf8ylvEniO3gR3JA23QsbABJ1Rk5bm9Yg",
                // authorizationToken: "Y9K8mqTyY8sSgHy2",
            },
            data: formData,
        };

        try {
            const response = await axios(config);
            console.log("API Response:", response.data);
            setInvoiceData(response.data.invoice_data); // ✅ Extract `invoice_data`
        } catch (error) {
            alert("Something went wrong with the server.");
            console.error(error);
        } finally {
            setLoading(true);
        }
    };

    return (
        <div className="container my-4">
            <h2 className="text-center mb-4">Invoice Analyzer</h2>

            {/* File Upload and Submit Button */}
            <div className="row justify-content-center mb-4">
                <div className="col-md-4 text-center">
                    <input type="file" className="form-control" onChange={onChange} accept="application/pdf" />
                </div>
                <div className="col-md-2 text-center">
                    {loading ? (
                        <button className="btn btn-primary" onClick={submit}>
                            Submit
                        </button>
                    ) : (
                        <ReactBootStrap.Spinner animation="border" />
                    )}
                </div>
            </div>

            {/* Invoice Details Table */}
            {invoiceData && (
                <div className="mt-4">
                    <h3>Invoice Details</h3>
                    <table className="table table-bordered table-hover">
                        <tbody>
                            <tr><th>Invoice Number</th><td>{invoiceData["Invoice number"] || "-"}</td></tr>
                            <tr><th>Buyer’s Order No</th><td>{invoiceData.Buyers_Order_No || "-"}</td></tr>
                            <tr><th>Ship to Address</th><td>{invoiceData["Ship to address"] || "-"}</td></tr>
                            <tr><th>Bill to Address</th><td>{invoiceData["Bill to address"] || "-"}</td></tr>
                            <tr><th>Bill Date</th><td>{invoiceData.Bill_date || "-"}</td></tr>
                            <tr><th>Description</th><td>{invoiceData.Description_of_services_or_product || "-"}</td></tr>
                            <tr><th>Bill Amount</th><td>₹{invoiceData.Bill_amount_of_services || "-"}</td></tr>
                            <tr><th>IGST Amount</th><td>₹{invoiceData.IGST_amount || "-"}</td></tr>
                            <tr><th>Total Bill Amount</th><td>₹{invoiceData.Total_Bill_amount || "-"}</td></tr>
                            <tr><th>Integrated Tax Rate</th><td>{invoiceData.Integrated_tax_rate || "-"}</td></tr>
                            <tr><th>Company Name</th><td>{invoiceData.Company_name || "-"}</td></tr>
                            <tr><th>Company GSTIN/UIN</th><td>{invoiceData["Company_GSTIN/UIN"] || "-"}</td></tr>
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default InvoiceAnalyzer;
